"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bilinear = void 0;
var linear_1 = require("../linear");
exports.bilinear = function (_a) {
    var x = _a.x, y = _a.y, x1 = _a.x1, y1 = _a.y1, x2 = _a.x2, y2 = _a.y2, q11 = _a.q11, q12 = _a.q12, q21 = _a.q21, q22 = _a.q22;
    var interResult1 = linear_1.linear({
        x: x,
        x1: x1,
        y1: q11,
        x2: x2,
        y2: q12,
    });
    var interResult2 = linear_1.linear({
        x: x,
        x1: x1,
        y1: q21,
        x2: x2,
        y2: q22,
    });
    return linear_1.linear({
        x: y,
        x1: y1,
        y1: interResult1,
        x2: y2,
        y2: interResult2,
    });
};
